import { SHARE_COUPON_DIALOG } from '@/config/dialog-manager-config';
import { spDialogList } from '@/config/sp-module-config';
import { ModuleName } from '@/types/module-config';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { DialogManager } from '@tencent/wphk-components-dialog-manager';
/**
 * 通用模块的弹窗列表
 * name:弹窗名称, order:弹窗展示顺序优先级，moduleName:弹窗关联的模块名
 * */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const commonDialogList = [
  { name: SHARE_COUPON_DIALOG, order: 45, moduleName: ModuleName.ShareCouponModule },
];

/**
 * 获取需要被弹窗管理的模块，
 * 同时处理针对spId专属展示的弹窗
 */
export const getDialogList = () => {
  const spId = getUrlParamByKey(UrlParamKey.spId);
  const targetSpDialogList = spDialogList.filter(item => item.spId === spId) || [];
  return commonDialogList.concat(targetSpDialogList);
};

export const dialogManager = new DialogManager({
  dialogList: getDialogList(),
  orderMode: 'ascend',
});
